import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobExtendExpiryComponent } from './job-extend-expiry.component';

@NgModule({
  declarations: [JobExtendExpiryComponent],
  imports: [CommonModule],
  exports: [JobExtendExpiryComponent],
})
export class JobExtendExpiryModule {}
